/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BranchPage = lazyLoad(
  () => import('./index'),
  module => module.BranchPage
);
